import { Table } from "semantic-ui-react";

import { InfoPopup } from "modules/CommunicationTemplates/components/InfoPopup";

type RenderDynamicTableContentType = {
  isEmailTemplate: boolean;
  showAcsesPlaceholders: boolean;
  displayReceptionistInfo: boolean;
  isConfirmationEmailMedium: boolean;
  showKeylockerPlaceholders: boolean;
  showParkingGateCodePlaceholder: boolean;
};

export const DynamicTableContent = ({
  isEmailTemplate,
  showAcsesPlaceholders,
  displayReceptionistInfo,
  showKeylockerPlaceholders,
  isConfirmationEmailMedium,
  showParkingGateCodePlaceholder
}: RenderDynamicTableContentType) => (
  <Table celled>
    <Table.Body>
      <Table.Row>
        <Table.Cell content="{{.Appointment.VIN}}" />
        <Table.Cell content="{{.Customer.Title}}" />
      </Table.Row>
      <Table.Row>
        <Table.Cell content="{{.Appointment.WONr}}" />
        <Table.Cell content={"{{.Customer.FullTitle}}"} />
      </Table.Row>
      <Table.Row>
        <Table.Cell content="{{.Appointment.CarMake}}" />
        <Table.Cell content="{{.Customer.FirstName}}" />
      </Table.Row>
      <Table.Row>
        <Table.Cell content="{{.Appointment.CarModel}}" />
        <Table.Cell content="{{.Customer.Surname}}" />
      </Table.Row>
      <Table.Row>
        <Table.Cell content="{{.Appointment.RegNumber}}" />
        <Table.Cell content="{{.DealerName}}" />
      </Table.Row>
      <Table.Row>
        <Table.Cell content={"{{.LocationPhone}}"} />
        <Table.Cell content="{{.LocationName}}" />
      </Table.Row>
      {isEmailTemplate && displayReceptionistInfo && (
        <>
          <Table.Row>
            <Table.Cell content="{{.Receptionist}}" />
            <Table.Cell content={"{{.ReceptionistProfilePictureURL}}"} />
          </Table.Row>
          <Table.Row>
            <Table.Cell content="{{.ReceptionistPhoneNumber}}" />
            <Table.Cell content="{{.Date}}" />
          </Table.Row>
        </>
      )}
      {isConfirmationEmailMedium && (
        <>
          <Table.Row>
            <Table.Cell
              content={
                <>
                  {"{{.YourOrder}}"}
                  <InfoPopup />
                </>
              }
            />
            <Table.Cell
              content={
                <>
                  {"{{.ContactedFor}}"}
                  <InfoPopup />
                </>
              }
            />
          </Table.Row>
          <Table.Row>
            <Table.Cell
              content={
                <>
                  {"{{.ScheduledServices}}"}
                  <InfoPopup />
                </>
              }
            />
            <Table.Cell
              content={
                <>
                  {"{{.ScheduledServicesAndYourOrder}}"}
                  <InfoPopup />
                </>
              }
            />
          </Table.Row>
        </>
      )}
      {(showKeylockerPlaceholders || showAcsesPlaceholders) && (
        <>
          <Table.Row>
            <Table.Cell content={"{{.KeyLockerPIN}}"} />
            <Table.Cell content={"{{.ShareboxLink}}"} />
          </Table.Row>
          {showAcsesPlaceholders && (
            <Table.Row>
              <Table.Cell content={"{{.AcsesLockerName}}"} />
              <Table.Cell content={"{{.AcsesBookingCode}}"} />
            </Table.Row>
          )}
        </>
      )}
      <Table.Row>
        {!(isEmailTemplate && displayReceptionistInfo) ? (
          <>
            <Table.Cell content={"{{.Date}}"} />
            <Table.Cell content="{{.Link}}" />
          </>
        ) : (
          <>
            <Table.Cell content="{{.Link}}" />
            <Table.Cell />
          </>
        )}
      </Table.Row>
      {showParkingGateCodePlaceholder && (
        <Table.Row>
          <Table.Cell content={"{{.ParkingGateCode}}"} />
          <Table.Cell />
        </Table.Row>
      )}
    </Table.Body>
  </Table>
);
